// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2fFkW","author":"Table_author__1SVho","authorImage":"Table_authorImage__1zpN1","unreadRow":"Table_unreadRow__2J1ba"};